/**
 * Evotor integration settings API client (BFF: `/api/v1/integrations/evotor/settings`).
 *
 * Tenant-intent toggles for the platform-wide Evotor↔OBZR sync pipeline's steps (→
 * evotor-integration-service). NOT the same resource as `retailEvotorApi.ts` (cloud-POS account/
 * store linking) — see `settingsTypes.ts`'s §23 comment for how the two relate.
 *
 * Confirmed BFF error contract: a `PUT` rejecting an unknown step key passes through as a plain
 * `400`; downstream (evotor-integration-service) unavailability surfaces as `502` with
 * `code: "BAD_GATEWAY"` — both flow through `@/shared/api`'s normal `NormalizedApiError`
 * normalisation like any other failure; no special-cased handling needed on this client.
 */
import { apiClient } from '@/shared/api';
import type {
  EvotorIntegrationSettings,
  UpdateEvotorIntegrationSettingsRequest,
} from '../model/settingsTypes';

const BASE = '/api/v1/integrations/evotor/settings';

export const getEvotorIntegrationSettings = async (): Promise<EvotorIntegrationSettings> =>
  (await apiClient.get<EvotorIntegrationSettings>(BASE)).data;

export const updateEvotorIntegrationSettings = async (
  body: UpdateEvotorIntegrationSettingsRequest,
): Promise<EvotorIntegrationSettings> =>
  (await apiClient.put<EvotorIntegrationSettings>(BASE, body)).data;
